// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ProjectFilledSvg from "@ant-design/icons-svg/es/asn/ProjectFilled";
import AntdIcon from '../components/AntdIcon';

var ProjectFilled = function ProjectFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ProjectFilledSvg
  }));
};

ProjectFilled.displayName = 'ProjectFilled';
export default React.forwardRef(ProjectFilled);